import {createTheme, CssBaseline} from "@mui/material";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {CustomThemeProvider} from "components/CustomThemeProvider/CustomThemeProvider";
import {Routing} from "Routing";
import "./App.css";
import {I18nContextProvider, NotificationContextProvider} from "react-admin";
import {i18nProvider} from "i18nProvider";
import {ReactQueryDevtools} from "@tanstack/react-query-devtools";

declare module "@tanstack/react-query" {
  interface Register {
    defaultError: any;
  }
}

const queryClient = new QueryClient();

const themes = {
  light: createTheme({
    palette: {
      mode: "light",
      primary: {
        main: "#fb5f2e",
      },
      secondary: {
        main: "#42a5f5",
      },
      background: {
        default: "#e8e5e3",
      },
    },
  }),
  dark: createTheme({
    palette: {
      mode: "dark",
      primary: {
        main: "#fb5f2e",
      },
      secondary: {
        main: "#42a5f5",
      },
      background: {
        default: "#000",
        paper: "#141414",
      },
    },
  }),
};

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <CustomThemeProvider>
        <I18nContextProvider value={i18nProvider}>
          <NotificationContextProvider>
            <CssBaseline/>
            <Routing/>
          </NotificationContextProvider>
        </I18nContextProvider>
      </CustomThemeProvider>
      <ReactQueryDevtools initialIsOpen={false}/>
    </QueryClientProvider>

    // <AdminContext
    //   darkTheme={themes.dark}
    //   i18nProvider={i18nProvider}
    //   queryClient={queryClient}
    //   theme={themes.light}
    // >
    //
    // </AdminContext>
    // <QueryClientProvider client={queryClient}>
    //   <CustomThemeProvider>
    //     <CustomLocalizationProvider>
    //       <CssBaseline />
    //       <GlobalSnackBar>
    //         <Routing />
    //         <Admin>

    //         </Admin>
    //       </GlobalSnackBar>
    //     </CustomLocalizationProvider>
    //   </CustomThemeProvider>
    //   <ReactQueryDevtools initialIsOpen={false} />
    // </QueryClientProvider>
  );
}

export default App;
